import { useState } from 'react'
import { DetailsList, DetailsListLayoutMode, SelectionMode } from '@fluentui/react'
import { CostBasis, RecentMessageItem } from '../../api/models'
import ConversationModal from '../conversations/ConversationModal'
import { useConversationById } from '../conversations/useConversationById'
import PerformancePanel from './PerformancePanel'
import { buildAnswerColumns } from './answerColumns'

type RecentMessagesTableProps = {
  items: RecentMessageItem[]
  costBasis: CostBasis
}

const RecentMessagesTable = ({ items, costBasis }: RecentMessagesTableProps) => {
  const [openConversationId, setOpenConversationId] = useState<string | null>(null)
  const modalContent = useConversationById(openConversationId)

  return (
    <PerformancePanel
      title="Recent messages sent to the model"
      isEmpty={items.length === 0}
      emptyMessage="No messages recorded for this period."
    >
      <div style={{ overflowX: 'auto' }}>
        <DetailsList
          items={items}
          columns={buildAnswerColumns({
            costBasis,
            onOpenConversation: setOpenConversationId,
          })}
          getKey={(item: RecentMessageItem) => item.telemetry_id.toString()}
          selectionMode={SelectionMode.none}
          layoutMode={DetailsListLayoutMode.justified}
          ariaLabelForGrid="Recent messages sent to the model"
          onShouldVirtualize={() => false}
        />
      </div>
      <ConversationModal content={modalContent} onDismiss={() => setOpenConversationId(null)} />
    </PerformancePanel>
  )
}

export default RecentMessagesTable
